import React, { lazy } from "react";
// import AllCollection from "../Component/Collection/AllCollection";
// import ExamOrders from "../Component/ExamOrders/ExamOrders";
// import Updates from "../Component/Updates/Updates";
// import AddUpdates from "../Component/Updates/AddUpdates";
// import Dashboard from "../Component/Dashboard/Dashboard";
// import Student from "../Component/Student/Student";
// import CategoryMaster from "../Component/CategoryMaster/CategoryMaster";
// import SubCategoryMaster from "../Component/SubCategoryMaster/SubCategoryMaster";
// import SubjectMaster from "../Component/SubjectMaster/SubjectMaster";
// import TopicMaster from "../Component/TopicMaster/TopicMaster";
// import QuestionBank from "../Component/QuestionBank/QuestionBank";
// import QuestionBankView from "../Component/QuestionBank/QuestionBankView";
// import Pearls from "../Component/Pearls/Pearls";
// import AddPearls from "../Component/Pearls/AddPearls";
// import Plans from "../Component/Plans/Plans";
// import AddPlans from "../Component/Plans/AddPlans";
// import EditPlans from "../Component/Plans/EditPlans";
// import Coupons from "../Component/Coupons/Coupons";
// import AddCoupons from "../Component/Coupons/AddCoupons";
// import EditCoupons from "../Component/Coupons/EditCoupons";
// import ViewCoupons from "../Component/Coupons/ViewCoupons";
// import QuestionMaster from "../Component/QuestionMaster/QuestionMaster";
// import QMListTable from "../Component/QuestionMaster/QMListTable";
// import QMView from "../Component/QuestionMaster/QMView";
// import Exams from "../Component/Exams/Exams";
// import AddExamTable from "../Component/Exams/AddExamTable";
// import CreateExam from "../Component/Exams/CreateExam";
// import YearMaster from "../Component/TestSeries/YearMaster";
// import TestList from "../Component/TestSeries/TestList";

//lazy load
const ExamOrders = lazy(() => import('../Component/ExamOrders/ExamOrders'));
const Dashboard = lazy(() => import('../Component/Dashboard/Dashboard'));
const Student = lazy(() => import('../Component/Student/Student'));
const CategoryMaster = lazy(() => import('../Component/CategoryMaster/CategoryMaster'));
const SubCategoryMaster = lazy(() => import('../Component/SubCategoryMaster/SubCategoryMaster'));
const SubjectMaster = lazy(() => import('../Component/SubjectMaster/SubjectMaster'));
const TopicMaster = lazy(() => import('../Component/TopicMaster/TopicMaster'));
const QuestionBank = lazy(() => import('../Component/QuestionBank/QuestionBank'));
const QuestionBankView = lazy(() => import('../Component/QuestionBank/QuestionBankView'));
const Pearls = lazy(() => import('../Component/Pearls/Pearls'));
const AddPearls = lazy(() => import('../Component/Pearls/AddPearls'));
const Plans = lazy(() => import('../Component/Plans/Plans'));
const PlansSubTable = lazy(() => import('../Component/Plans/PlansSubTable'));
const AddPlans = lazy(() => import('../Component/Plans/AddPlans'));
const EditPlans = lazy(() => import('../Component/Plans/EditPlans'));
const Coupons = lazy(() => import('../Component/Coupons/Coupons'));
const AddCoupons = lazy(() => import('../Component/Coupons/AddCoupons'));
const EditCoupons = lazy(() => import('../Component/Coupons/EditCoupons'));
const ViewCoupons = lazy(() => import('../Component/Coupons/ViewCoupons'));
const QuestionMaster = lazy(() => import('../Component/QuestionMaster/QuestionMaster'));
const QMListTable = lazy(() => import('../Component/QuestionMaster/QMListTable'));
const QMView = lazy(() => import('../Component/QuestionMaster/QMView'));
const Exams = lazy(() => import('../Component/Exams/Exams'));
const AddExamTable = lazy(() => import('../Component/Exams/AddExamTable'));
const ExamSubcategoryTable = lazy(() => import('../Component/Exams/ExamSubcategoryTable'));
const CreateExam = lazy(() => import('../Component/Exams/CreateExam'));
const YearMaster = lazy(() => import('../Component/TestSeries1/YearMaster'));
const TestList = lazy(() => import('../Component/TestSeries1/TestList'));
const VideosCategoryTable = lazy(() => import('../Component/Videos/VideosCategoryTable'));
const InstructorTable = lazy(() => import('../Component/Videos/InstructorTable'));
const VideosListTable = lazy(() => import('../Component/Videos/VideosListTable'));
const AddVideo = lazy(() => import('../Component/Videos/AddVideo'));
const Updates = lazy(() => import('../Component/Updates/Updates'));
const AddUpdates = lazy(() => import('../Component/Updates/AddUpdates'));
const BannerList = lazy(() => import('../Component/Banner/BannerList'));
const CreateBanner = lazy(() => import('../Component/Banner/CreateBanner'));
const VideoOrders = lazy(() => import('../Component/VideoOrders/VideoOrders'));
const PearlsCategory = lazy(() => import('../Component/Pearls/PearlsCategory'));
const PearlsSubCategory = lazy(() => import('../Component/Pearls/PearlsSubCategory'));
const PearlsOrders = lazy(() => import('../Component/PearlsOrders/PearlsOrders'));
const UpdatesOrders = lazy(() => import('../Component/UpdatesOrders/UpdatesOrders'));
const UpdatesCategory = lazy(() => import('../Component/Updates/UpdatesCategory'));
const UpdatesSubCategory = lazy(() => import('../Component/Updates/UpdatesSubCategory'));
const ImageUpload = lazy(() => import('../Component/ImageUpload/ImageUpload'));
const AddOfflineStudent = lazy(() => import('../Component/Student/AddOfflineStudent'));
const TPCouponList = lazy(() => import('../Component/TPCoupon/TPCouponList'));
const TPAddCoupon = lazy(() => import("../Component/TPCoupon/TPAddCoupon"));
const TPEditCoupon = lazy(() => import("../Component/TPCoupon/TPEditCoupon"));
const FeedBackList = lazy(() => import('../Component/Exams/FeedBackList'));
const FeedBackView = lazy(() => import('../Component/Exams/FeedBackView'));
const VideoErrorLog = lazy(() => import('../Component/VideoErrorLog/VideoErrorLog'));

const StudentDetails = lazy(() => import('../Component/Student/StudentDetails'));

//Notification

const CreateNotification = lazy(() => import('../Component/Notification/CreateNotification'));
const CreateMultiNotification = lazy(() => import('../Component/Notification/CreateMultiNotification'));
const NotificationList = lazy(() => import('../Component/Notification/NotificationList'));

//InAppMessage

const InAppMessageList = lazy(() => import('../Component/InAppMessage/InAppMessageList'));
const CreateInAppMessageList = lazy(() => import('../Component/InAppMessage/CreateInAppMessageList'));
const CreateMultiInAppMessageList = lazy(() => import('../Component/InAppMessage/CreateMultiInAppMessageList'));

//TestSeries
const TestSeriesCategory = lazy(() => import('../Component/TestSeries/TestSeriesCategory'));
const TestSeriesSubCategory = lazy(() => import('../Component/TestSeries/TestSeriesSubCategory'));
const MonthWiseTable = lazy(() => import('../Component/TestSeries/MonthWiseTable'));
const TSExamTable = lazy(() => import('../Component/TestSeries/TSExamTable'));
const TSExamDetails = lazy(() => import('../Component/TestSeries/TSExamDetails'));
const TSQuestionView = lazy(() => import('../Component/TestSeries/TSQuestionView'));
const TsExamAnalysis = lazy(() => import('../Component/TestSeries/TsExamAnalysis'));

//DNBMD
const DNBMDCategoryTable = lazy(() => import('../Component/DNBMD/DNBMDCategory'));
const DNBMDOrder = lazy(() => import('../Component/DNBMD/DNBMDOrder'));
const DNBMDSubCategory = lazy(() => import('../Component/DNBMD/DNBMDSubCategory'));
const DNBMD = lazy(() => import('../Component/DNBMD/DNBMD'));
const AddDNBMD = lazy(() => import('../Component/DNBMD/AddDNBMD'));

//AccessSettingsList
const AccessSettingsList = lazy(() => import('../Component/AccessSettings/AccessSettingsList'));
const AddAccessSettings = lazy(() => import('../Component/AccessSettings/AddAccessSettings'));
const EditAccessSettings = lazy(() => import('../Component/AccessSettings/EditAccessSettings'));
const StaffList = lazy(() => import('../Component/AccessSettings/StaffList'));
const HtmlTest = lazy(() => import('../Component/HtmlTest/HtmlTest'));

//
const CouponsAnalytics = lazy(() => import('../Component/Coupons/CouponsAnalytics'));
const CouponStudentDetails = lazy(() => import('../Component/Coupons/CouponStudentDetails'));
const ViewSales = lazy(() => import('../Component/Plans/ViewSales'));
//collection details
const AllCollection = lazy(() => import('../Component/Collection/AllCollection'));
// const InvCollection = lazy(()=> import('../Component/Collection/InvCollection'));
const AttemptExam = lazy(() => import('../Component/Exams/AttemptExam'));

//vidoe v2
const VideosSpecialityTable = lazy(() => import('../Component/VideoV2/VideosSpecialityTable'));
const VideosTopicTable = lazy(() => import('../Component/VideoV2/VideosTopicTable'));
const VideosSubTopicTable = lazy(() => import('../Component/VideoV2/VideosSubTopicTable'));
const VideosV2ListTable = lazy(() => import('../Component/VideoV2/VideosV2ListTable'));

//qbank v2

const QbankSpecialityTable = lazy(() => import('../Component/QbankV2/QbankSpecialityTable'));
const QbankTopicTable = lazy(() => import('../Component/QbankV2/QbankTopicTable'));
const QbankSubTopicTable = lazy(() => import('../Component/QbankV2/QbankSubTopicTable'));
const QbankV2ListTable = lazy(() => import('../Component/QbankV2/QbankV2ListTable'));


//pearls v2
const PearlsSpecialityTable = lazy(() => import('../Component/PearlsV2/PearlsSpecialityTable'));
const PearlsTopicTable = lazy(() => import('../Component/PearlsV2/PearlsTopicTable'));
const PearlsSubTopicTable = lazy(() => import('../Component/PearlsV2/PearlsSubTopicTable'));
const PearlsV2ListTable = lazy(() => import('../Component/PearlsV2/PearlsV2ListTable'));

//updates v2
const UpdatesSubTopicTable = lazy(() => import('../Component/UpdatesV2/UpdatesSubTopicTable'));
const UpdatesTopicTable = lazy(() => import('../Component/UpdatesV2/UpdatesTopicTable'));
const UpdatesSpecialityTable = lazy(() => import('../Component/UpdatesV2/UpdatesSpecialityTable'));
const UpdatesV2ListTable = lazy(() => import('../Component/UpdatesV2/UpdatesV2ListTable'));

//DNBMD v2
const DNBMDSpecialityTable = lazy(() => import('../Component/DNBMDV2/DNBMDSpecialityTable'));
const DNBMDTopicTable = lazy(() => import('../Component/DNBMDV2/DNBMDTopicTable'));
const DNBMDSubTopicTable = lazy(() => import('../Component/DNBMDV2/DNBMDSubTopicTable'));
const DNBMDV2ListTable = lazy(() => import('../Component/DNBMDV2/DNBMDV2ListTable'));

// AI Chat
const AiChatOverview = lazy(() => import('../Component/AiChat/AiChatOverview'));
const AiChatLogs = lazy(() => import('../Component/AiChat/AiChatLogs'));
const AiChatSettings = lazy(() => import('../Component/AiChat/AiChatSettings'));
const AiChatAccessRules = lazy(() => import('../Component/AiChat/AiChatAccessRules'));
// Monitoring Dashboard
const MonitoringDashboard = lazy(() => import('../Component/MonitoringDashboard/MonitoringDashboard'));
const VideoIssuesAnalysis = lazy(() => import('../Component/MonitoringDashboard/VideoIssuesAnalysis'));

// Salesman & Billing
const SalesmanList = lazy(() => import('../Component/Salesman/SalesmanList'));
const SalesmanForm = lazy(() => import('../Component/Salesman/SalesmanForm'));
const BillingList = lazy(() => import('../Component/Billing/BillingList'));
const BillDetails = lazy(() => import('../Component/Billing/BillDetails'));
const OrderLogs = lazy(() => import('../Component/OrderLogs/OrderLogs'));
const R2ContentSync = lazy(() => import('../Component/R2ContentSync/R2ContentSync'));

export const authRoutes = [
  {
    path: "/attemptexams/:id",
    exact: true,
    element: <AttemptExam />,
  },
  {
    path: "/all_collection",
    exact: true,
    element: <AllCollection />,
  },
  {
    path: "/view_sales",
    exact: true,
    element: <ViewSales />,
  },
  {
    path: "/coupon/student_details/:cid/:did",
    exact: true,
    element: <CouponStudentDetails />,
  },
  {
    path: "/couponsanalytics/:id",
    exact: true,
    element: <CouponsAnalytics />,
  },
  {
    path: "/html_testing",
    exact: true,
    element: <HtmlTest />,
  },
  {
    path: "/staff",
    exact: true,
    element: <StaffList />,
  },
  {
    path: "/access_settings",
    exact: true,
    element: <AccessSettingsList />,
  },
  {
    path: "/access_settings/add",
    exact: true,
    element: <AddAccessSettings />,
  },
  {
    path: "/access_settings/edit/:id",
    exact: true,
    element: <EditAccessSettings />,
  },
  {
    path: "/",
    exact: true,
    element: <Dashboard />,
  },
  {
    path: "/student",
    exact: true,
    element: <Student />,
  },
  {
    path: "/student_details/:id",
    exact: true,
    element: <StudentDetails />,
  },
  {
    path: "/offlinestudent",
    exact: true,
    element: <AddOfflineStudent />,
  },
  {
    path: "/categorymaster",
    exact: true,
    element: <CategoryMaster />,
  },
  {
    path: "/subcategorymaster/:cid",
    exact: true,
    element: <SubCategoryMaster />,
  },
  {
    path: "/subjectmaster/:cid/:scid",
    exact: true,
    element: <SubjectMaster />,
  },
  {
    path: "/topicmaster/:cid/:scid/:sid",
    exact: true,
    element: <TopicMaster />,
  },
  {
    path: "/questionbank/:cid/:scid/:sid/:tid",
    exact: true,
    element: <QuestionBank />,
  },
  {
    path: "/questionbankview/:qid",
    exact: true,
    element: <QuestionBankView />,
  },
  {
    path: "/pearls",
    exact: true,
    element: <PearlsSpecialityTable />,
  },
  {
    path: "/pearls_topic/:sid",
    exact: true,
    element: <PearlsTopicTable />,
  },
  {
    path: "/pearls_subtopic/:sid",
    exact: true,
    element: <PearlsSubTopicTable />,
  },
  {
    path: "/pearls_list_v2/:tid",
    exact: true,
    element: <PearlsV2ListTable />,
  },
  {
    path: "/pearlsorder",
    exact: true,
    element: <PearlsOrders />,
  },
  {
    path: "/pearlssubcategory/:cid",
    exact: true,
    element: <PearlsSubCategory />,
  },
  {
    path: "/pearlssubject/:cid/:scid",
    exact: true,
    element: <Pearls />,
  },
  {
    path: "/addpearls/:scid/:sid",
    exact: true,
    element: <AddPearls />,
  },
  {
    path: "/plans",
    exact: true,
    element: <Plans />
  },
  {
    path: "/plans/:pid",
    exact: true,
    element: <PlansSubTable />
  },
  {
    path: "/addplans",
    exact: true,
    element: <AddPlans />
  },
  {
    path: "/editplans/:pid",
    exact: true,
    element: <EditPlans />
  },
  {
    path: "/coupons",
    exact: true,
    element: <Coupons />
  },
  {
    path: "/addcoupons",
    exact: true,
    element: <AddCoupons />
  },
  {
    path: "/editcoupons/:cid",
    exact: true,
    element: <EditCoupons />
  },
  {
    path: "/viewcoupons/:cid",
    exact: true,
    element: <ViewCoupons />
  },
  // {
  //   path:"/tp_coupons",
  //   exact: true,
  //   element: <Coupons />
  // },
  // {
  //   path:"/tp_addcoupons",
  //   exact: true,
  //   element: <TPAddCoupon />
  // },
  // {
  //   path:"/tp_editcoupons/:cid",
  //   exact: true,
  //   element: <TPEditCoupon />
  // },
  {
    path: "/questionmaster",
    exact: true,
    element: <QuestionMaster />
  },
  {
    path: "/addquestionmaster/:cid",
    exact: true,
    element: <QMListTable />
  },
  {
    path: "/qmview/:qid",
    exact: true,
    element: <QMView />
  },
  {
    path: "/exams",
    exact: true,
    element: <QbankSpecialityTable />
  },
  {
    path: "/exams_topic/:sid",
    exact: true,
    element: <QbankTopicTable />
  },
  {
    path: "/exams_subtopic/:sid",
    exact: true,
    element: <QbankSubTopicTable />
  },
  {
    path: "/exams_list_v2/:tid",
    exact: true,
    element: <QbankV2ListTable />
  },
  {
    path: "/addexams/:cid",
    exact: true,
    element: <ExamSubcategoryTable />
  },
  {
    path: "/addexamssub/:cid/:sid",
    exact: true,
    element: <AddExamTable />
  },
  {
    path: "/publishexams/:eid",
    exact: true,
    element: <CreateExam />
  },
  // {
  //   path:"/yearmaster",
  //   exact: true,
  //   element: <YearMaster />
  // },
  {
    path: "/testseries",
    exact: true,
    element: <TestSeriesCategory />
  },
  {
    path: "/testseries_subcategory/:cid",
    exact: true,
    element: <TestSeriesSubCategory />
  },
  {
    path: "/ts_month_wise/:cid/:scid",
    exact: true,
    element: <MonthWiseTable />
  },
  {
    path: "/ts_exam_list/:mid",
    exact: true,
    element: <TSExamTable />
  },
  {
    path: "/ts_exam_details/:id",
    exact: true,
    element: <TSExamDetails />
  },
  {
    path: "/ts_question_view/:qid/:sid",
    exact: true,
    element: <TSQuestionView />
  },
  {
    path: "/ts_analysis_view/:eid",
    exact: true,
    element: <TsExamAnalysis />
  },
  {
    path: "/videoscategory",
    exact: true,
    element: <VideosSpecialityTable />
  },
  {
    path: "/videos_topic/:sid",
    exact: true,
    element: <VideosTopicTable />
  },
  {
    path: "/videos_subtopic/:sid",
    exact: true,
    element: <VideosSubTopicTable />
  },
  {
    path: "/videosv2list/:tid",
    exact: true,
    element: <VideosV2ListTable />
  },
  {
    path: "/instructorlist",
    exact: true,
    element: <InstructorTable />
  },
  {
    path: "/videoslist/:cid",
    exact: true,
    element: <VideosListTable />
  },
  {
    path: "/publishvideos/:vid",
    exact: true,
    element: <AddVideo />
  },
  {
    path: "/updates",
    exact: true,
    element: <UpdatesSpecialityTable />,
  },
  {
    path: "/updates_topic/:sid",
    exact: true,
    element: <UpdatesTopicTable />,
  },
  {
    path: "/updates_subtopic/:sid",
    exact: true,
    element: <UpdatesSubTopicTable />,
  },
  {
    path: "/updates_list_v2/:tid",
    exact: true,
    element: <UpdatesV2ListTable />,
  },
  {
    path: "/updatessubcategory/:cid",
    exact: true,
    element: <UpdatesSubCategory />,
  },
  {
    path: "/updatessubject/:cid/:scid",
    exact: true,
    element: <Updates />,
  },
  {
    path: "/updatesorder",
    exact: true,
    element: <UpdatesOrders />,
  },
  {
    path: "/addupdates/:scid/:sid",
    exact: true,
    element: <AddUpdates />,
  },
  {
    path: "/banner_list",
    exact: true,
    element: <BannerList />,
  },
  {
    path: "/banner/create",
    exact: true,
    element: <CreateBanner />,
  },
  {
    path: "/banner/edit/:id",
    exact: true,
    element: <CreateBanner />,
  },
  {
    path: "/videoorders",
    exact: true,
    element: <VideoOrders />,
  },
  {
    path: "/videoerrorlogs",
    exact: true,
    element: <VideoErrorLog />,
  },
  {
    path: "/examoorders",
    exact: true,
    element: <ExamOrders />,
  },
  {
    path: "/imageupload",
    exact: true,
    element: <ImageUpload />,
  },
  {
    path: "/feedbacks",
    exact: true,
    element: <FeedBackList />,
  },
  {
    path: "/feedbacks/view/:fid",
    exact: true,
    element: <FeedBackView />,
  },
  {
    path: "/notification_list",
    exact: true,
    element: <NotificationList />,
  },
  {
    path: "/add_notification",
    exact: true,
    element: <CreateNotification />,
  },
  {
    path: "/add_multi_notification",
    exact: true,
    element: <CreateMultiNotification />,
  },
  {
    path: "/inappmessage_list",
    exact: true,
    element: <InAppMessageList />,
  },
  {
    path: "/add_inappmessage",
    exact: true,
    element: <CreateInAppMessageList />,
  },
  {
    path: "/add_multi_inappmessage",
    exact: true,
    element: <CreateMultiInAppMessageList />,
  },
  {
    path: "/dnb_md",
    exact: true,
    element: <DNBMDSpecialityTable />,
  },
  {
    path: "/dnbmds_topic/:sid",
    exact: true,
    element: <DNBMDTopicTable />,
  },
  {
    path: "/dnbmds_subtopic/:sid",
    exact: true,
    element: <DNBMDSubTopicTable />,
  },
  {
    path: "/dnbmds_list_v2/:tid",
    exact: true,
    element: <DNBMDV2ListTable />,
  },
  {
    path: "/dnb_md_order",
    exact: true,
    element: <DNBMDOrder />,
  },
  {
    path: "/dnb_md_subcategory/:cid",
    exact: true,
    element: <DNBMDSubCategory />,
  },
  {
    path: "/dnb_md_subject/:cid/:scid",
    exact: true,
    element: <DNBMD />,
  },
  {
    path: "/adddnbmd/:scid/:sid",
    exact: true,
    element: <AddDNBMD />,
  },
  {
    path: "/aichat/overview",
    exact: true,
    element: <AiChatOverview />,
  },
  {
    path: "/aichat/logs",
    exact: true,
    element: <AiChatLogs />,
  },
  {
    path: "/aichat/settings",
    exact: true,
    element: <AiChatSettings />,
  },
  {
    path: "/aichat/access",
    exact: true,
    element: <AiChatAccessRules />,
  },
  {
    path: "/monitoring/dashboard",
    exact: true,
    element: <MonitoringDashboard />,
  },
  {
    path: "/monitoring/dashboard/video-issues-analysis",
    exact: true,
    element: <VideoIssuesAnalysis />,
  },
  {
    path: "/salesman",
    exact: true,
    element: <SalesmanList />,
  },
  {
    path: "/addsalesman",
    exact: true,
    element: <SalesmanForm />,
  },
  {
    path: "/editsalesman/:id",
    exact: true,
    element: <SalesmanForm />,
  },
  {
    path: "/billing",
    exact: true,
    element: <BillingList />,
  },
  {
    path: "/billing/details/:id",
    exact: true,
    element: <BillDetails />,
  },
  {
    path: "/orderlogs",
    exact: true,
    element: <OrderLogs />,
  },
  {
    path: "/r2_sync",
    exact: true,
    element: <R2ContentSync />,
  },
];

